// @tennis-matches/ui/tournament-setup/schleifchenWizardOptions.js
// Shared Schleifchen/MatchMixer wizard presets (RulesStep + AI chat wizard).

/** Lucide icon component names for preset ids (resolved in consumers). */
export const MODE_ICON_NAMES = Object.freeze({
  classic: "Crosshair",
  competitive: "Swords",
  timebox: "Clock",
  playoffs: "Trophy",
});

/**
 * Modus-Presets (Klassisch, Wettkampf, Zeitspiel, Playoffs).
 *
 * `bulletKeys` ist die statische Reihenfolge der Bullet-Keys.
 * `bulletParamBuilders` (optional, je Preset) erlaubt dynamische i18n-Parameter
 * abhängig vom UI-Kontext (z. B. aktuelle Rundendauer); siehe `RulesStep` Prop
 * `bulletContext`.
 */
export const SCHLEIFCHEN_MODE_PRESETS = Object.freeze([
  {
    id: "classic",
    labelKey: "settings.wizard.modePreset.classic",
    descKey: "settings.wizard.modePreset.classic.desc",
    bulletKeys: [
      "matchmixer.setup.mode.classic.bullet.minutesPerRound",
      "matchmixer.setup.mode.classic.bullet.winPoints",
      "matchmixer.setup.mode.classic.bullet.drawPoints",
    ],
    bulletParamBuilders: {
      "matchmixer.setup.mode.classic.bullet.minutesPerRound": (ctx) => ({
        minutes: Number(ctx?.minutesPerRound) > 0 ? Number(ctx.minutesPerRound) : 15,
      }),
    },
    rrModeValue: "ONE_SET_OPEN",
    recommended: true,
  },
  {
    id: "competitive",
    labelKey: "settings.wizard.modePreset.competitive",
    descKey: "settings.wizard.modePreset.competitive.desc",
    bulletKeys: [
      "settings.wizard.modePreset.competitive.bullet1",
      "settings.wizard.modePreset.competitive.bullet2",
      "settings.wizard.modePreset.competitive.bullet3",
    ],
    rrModeValue: "ONE_SET_TB",
  },
  {
    id: "timebox",
    labelKey: "settings.wizard.modePreset.timebox",
    descKey: "settings.wizard.modePreset.timebox.desc",
    bulletKeys: [
      "settings.wizard.modePreset.timebox.bullet1",
      "settings.wizard.modePreset.timebox.bullet2",
      "settings.wizard.modePreset.timebox.bullet3",
    ],
    rrModeValue: null,
    badge: "comingSoon",
  },
  {
    id: "playoffs",
    labelKey: "settings.wizard.modePreset.playoffs",
    descKey: "settings.wizard.modePreset.playoffs.desc",
    bulletKeys: [
      "settings.wizard.modePreset.playoffs.bullet1",
      "settings.wizard.modePreset.playoffs.bullet2",
      "settings.wizard.modePreset.playoffs.bullet3",
    ],
    rrModeValue: "TWO_SETS_MTB",
  },
]);

/** RR-Scoring-Optionen (Expert / AI-Wizard Schritt „scoring“). */
export const SCHLEIFCHEN_SCORING_OPTIONS = Object.freeze([
  { value: "ONE_SET_OPEN", key: "settings.rr.mode.oneSetOpen", recommended: true },
  { value: "ONE_SET_TB", key: "settings.rr.mode.oneSetTb" },
  { value: "TWO_SETS_MTB", key: "settings.rr.mode.twoSetsMtb", badge: "new" },
]);

/**
 * Presets für UI-Auswahl (ohne „coming soon“ / ohne rrModeValue).
 * @returns {typeof SCHLEIFCHEN_MODE_PRESETS[number][]}
 */
export function getSelectableModePresets() {
  return SCHLEIFCHEN_MODE_PRESETS.filter((p) => p.rrModeValue != null && p.badge !== "comingSoon");
}
